import React, { useState } from "react";
import { PrivacyPolicyDialog, TermsOfServiceDialog } from "@/components/LegalDialogs";
import SupportDialog from "@/components/SupportDialog";

export default function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [supportOpen, setSupportOpen] = useState(false);

  return (
    <footer
      data-testid="app-footer"
      className="border-t border-border py-4 text-center text-xs text-muted-foreground"
    >
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
        <span>&copy;2026. All rights reserved.</span>
        <span className="text-border" aria-hidden="true">·</span>
        <button
          type="button"
          data-testid="footer-privacy-link"
          onClick={() => setPrivacyOpen(true)}
          className="hover:text-primary hover:underline transition-colors"
        >
          Privacy Policy
        </button>
        <span className="text-border" aria-hidden="true">·</span>
        <button
          type="button"
          data-testid="footer-terms-link"
          onClick={() => setTermsOpen(true)}
          className="hover:text-primary hover:underline transition-colors"
        >
          Terms of Service
        </button>
        <span className="text-border" aria-hidden="true">·</span>
        <button
          type="button"
          data-testid="footer-support-link"
          onClick={() => setSupportOpen(true)}
          className="hover:text-primary hover:underline transition-colors"
        >
          Support
        </button>
      </div>

      <PrivacyPolicyDialog open={privacyOpen} onOpenChange={setPrivacyOpen} />
      <TermsOfServiceDialog open={termsOpen} onOpenChange={setTermsOpen} />
      {/* Public contact form — usable when not logged in / can't sign in. */}
      <SupportDialog open={supportOpen} onOpenChange={setSupportOpen} mode="public" />
    </footer>
  );
}
